import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import CreateLot from "./CreateLot";
import LotTable from "./LotTable";
import Sidebar from "../../Sidebar";
import LotAccordion from "./Lot-Accordion";

const Lots = (props) => {
  const parkingLots = props.parkingLots;
  const getAllLots = props.getAllLots;
  const navigate = props.navigate;

  useEffect(() => {
    if (props.token) {
      getAllLots();
    }
  }, [props.token]);
  return (
    <>
      {/* <div className="container-fluid">
      <div className="row">
        <div className="col-md-3">
          <Sidebar />
        </div>
      </div>
    </div> */}

      <Container>
        <Row>
          <Col md="4">
            {/* <CreateLot token={props.token} getAllLots={getAllLots} />
             */}
            <LotAccordion token={props.token} getAllLots={getAllLots} />
          </Col>
          <Col md="8">
            <LotTable
              navigate={navigate}
              parkingLots={parkingLots}
              token={props.token}
              getAllLots={getAllLots}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Lots;
